import { Divider, MenuItem } from '@mui/material';
import { Fragment, useState } from 'react';
import useSWR from 'swr';
import { NContact } from '@modules/ContactManager/components/Tabs/components/Contact/validation';
import { openPdf, queryParams } from 'app/shared/commonFunctions';
import { Notistack } from 'app/shared/components/Notistack/Notistack';
import { SERVICES } from 'app/shared/constants/apiConfig';
import { IAsset } from '../../../../Assets/interfaces';
import { IDocsTitleMenuProps } from '../../../interfaces';
import { DOC_TYPES, IDocsMenu, IDocumentGenerate } from '../../DocsMenu/interface';
import { requestDocumentGenerate, requestToGeneratePdf } from '../../DocsMenu/queries';

const menuItems: IDocsMenu[] = [
  {
    docTypeId: DOC_TYPES.TITLE_AUDIT,
    id: 1,
    name: 'Title Audit',
    divider: true,
  },
  {
    docTypeId: DOC_TYPES.TITLE_APP,
    id: 2,
    name: 'Title App',
  },
];
export const DocsTitleMenu = ({ handleClose, assetId, setLoading }: IDocsTitleMenuProps) => {
  const params = queryParams();
  const [docMenuItem, setDocMenuItem] = useState<IDocsMenu | null>(null);

  const contact = useSWR<NContact.Entity>(`/${SERVICES.CONTACT}/contacts/${params.id}`);
  const { data: asset } = useSWR<IAsset>(assetId && `${SERVICES.ASSET}/assets/${assetId}`);

  const handleDoc = (docsData: IDocumentGenerate) => {
    if (contact.data?.firstName && contact.data?.lastName && asset?.vin) {
      onDocGenerate(docsData);
    } else {
      let error = 'Product Submit Contract Error \n';
      error += (!contact.data?.firstName && '"FirstName" must not be empty \n') || '';
      error += (!contact.data?.lastName && '"LastName" must not be empty \n') || '';
      error += (!asset?.vin && '"Vin" must not be empty') || '';
      Notistack.generalError(error);
    }
  };

  const onDocGenerate = async(docsData: IDocumentGenerate) => {
    setLoading(true);
    const resp = await requestDocumentGenerate(docsData);
    if (resp === '200') {
      onPdfGenerate(docsData.dealId, docsData.documentGenerationType);
    } else {
      setDocMenuItem(null);
    }
    setLoading(false);
  };

  const onPdfGenerate = async(dealId: string, documentGenerationType: number) => {
    const text =
      docMenuItem?.docTypeId === DOC_TYPES.TITLE_DOCS
        ? 'Deal saved, generating title documents...'
        : 'Deal saved, generating documents...';

    Notistack.infoMessage(text);
    setLoading(true);

    const content = await requestToGeneratePdf(dealId, documentGenerationType);
    openPdf(content.document, content.fileName);
    setLoading(false);
  };

  const handleMenuItemClick = (item: IDocsMenu) => {
    setDocMenuItem(item);
    const data: IDocumentGenerate = {
      dealId: params.dealId,
      documentGenerationType: item.docTypeId,
      ignoreProducts: item.docTypeId !== DOC_TYPES.LENDER,
      isEmailCustomerTitleDocGen: false,
      isScanStipTitleDocGen: false,
      filterDocumentTypeIds: [],
    };
    handleClose();
    handleDoc(data);
  };

  return (
    <>
      {menuItems.map((item: IDocsMenu) => {
        return (
          <Fragment key={'menuKey ' + item.id}>
            <MenuItem onClick={() => handleMenuItemClick(item)}>{item.name}</MenuItem>
            {item.divider ? <Divider sx={{ my: 0.5 }} /> : null}
          </Fragment>
        );
      })}
    </>
  );
};
